import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';
import headers from '../constants/headers';

axios.defaults.headers.common.Authorization = `Bearer ${headers.access_token}`;

const entityService = {
  all({ page, limit, q}) {
    return axios.get(`${API_V2_URL()}/entities/entities?page=${page}&limit=${limit}&q=${q}`);
  },
  getEntity(query) {
    return axios.get(`${API_V2_URL()}/entities/search?q=${query}`);
  },
  createEntity(body) {
    return axios.post(`${API_V2_URL()}/entities/entities`, body);
  },
  searchEntityCNPJ(cpfCnpj) {
    return axios.get(`${API_V2_URL()}/entities/${cpfCnpj}/search`);
  },
  updateEntity(id, body) {
    return axios.put(`${API_V2_URL()}/entities/entities/${id}`, body);
  },
};

export default entityService;



// WEBPACK FOOTER //
// ./src/services/EntityService.js